var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-menu-search"},[_c('input',{attrs:{"type":"text","placeholder":_vm.t('side_menu', 'Search')},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }